import IPaymentMethod from '@/interfaces/Methods/Payment';
import { isValid } from '@/helpers/values';
import { EPaymentMethod, EPaymentMethodTypes } from '@/helpers/enums';

export default class PaymentMethod implements IPaymentMethod {
  id?: number | null = null;
  type: EPaymentMethodTypes;
  name?: string;
  method?: EPaymentMethod;
  subtitle?: string;
  discount_amount: number | null = null;
  discount_percentage: number | null = null;
  cart_final_price: number | null = null;
  isSelected: boolean = false;
  isAvailable: boolean = false;

  main_offer_payment_amount?: number | null = null;
  offer_payment_condition_id?: number | null = null;
  main_offer_payment_method?: EPaymentMethod;
  second_offer_payment_method?: EPaymentMethod;
  second_payment_condition: any | null = null;

  public toggleSelection(status: boolean): void {
    this.isSelected = isValid(status) ? status : !this.isSelected;
  }

  public toggleAvailability(status: boolean): void {
    this.isAvailable = isValid(status) ? status : !this.isAvailable;
  }
}
